'use strict';
module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/internals/is-pure.js
// module id = 41
// module chunks = 0